module.exports = __webpack_public_path__ + "img/IMG_3346_2028_P_T_L_Black_MockedUp.7a8ad69c.jpg";